import { useMemo } from 'react';
import ProgressByCurrentPeriod from '../../../../../CurriculumProgressStudent/parts/ProgressByCurrentPeriod';
import { useTranslation } from 'react-i18next';
import { Col } from 'reactstrap';
import BaseLoader from './parts/BaseLoader';
import { isNumber } from '../../../../../../utils/math';

interface ProgressInCurrentPeriodProps {
  studyPlanEnrollmentId: string | undefined;
}

export default function ProgressInCurrentPeriod({
  studyPlanEnrollmentId,
}: ProgressInCurrentPeriodProps) {
  const prefix = 'curriculumProgressStudent';
  const { t } = useTranslation();

  const texts = useMemo(
    () => ({
      progress: {
        table: {
          columns: {
            section: t(`${prefix}.progress.section`),
            courseCode: t(`${prefix}.progress.courseCode`),
            generalPassedAverage: t(`${prefix}.progress.generalPassedAverage`),
            averageGradeToDate: t(`${prefix}.progress.averageGradeToDate`),
            progressPorcentInGrades: t(
              `${prefix}.progress.progressPorcentInGrades`,
            ),
            averageAttendanceToDate: t(
              `${prefix}.progress.averageAttendanceToDate`,
            ),
            attendanceCatedral: t(`${prefix}.progress.attendanceCatedral`),
            attendanceLaboratory: t(`${prefix}.progress.attendanceLaboratory`),
            attendanceAssistantship: t(
              `${prefix}.progress.attendanceAssistantship`,
            ),
          },
          tooltips: {
            attendanceCatedral: t(
              `${prefix}.progress.tooltip.attendanceCatedral`,
            ),
            attendanceLaboratory: t(
              `${prefix}.progress.tooltip.attendanceLaboratory`,
            ),
            attendanceAssistantship: t(
              `${prefix}.progress.tooltip.attendanceAssistantship`,
            ),
          },
          notActivePeriod: {
            title: t(`${prefix}.progress.notActivePeriod.title`),
            subtitle: t(`${prefix}.progress.notActivePeriod.subtitle`),
          },
          notResult: {
            title: t(`${prefix}.progress.notResult.title`),
            subtitle: t(`${prefix}.progress.notResult.subtitle`),
          },
        },
      },
    }),
    [t],
  );

  const studyPlanEnrollmentIdValid = useMemo(() => {
    if (isNumber(studyPlanEnrollmentId)) {
      return Number(studyPlanEnrollmentId);
    }
    return null;
  }, [studyPlanEnrollmentId]);

  if (!studyPlanEnrollmentIdValid) {
    return (
      <h2 className="text-center">
        {t('studentManagement.academicHistory.noStudyPlanEnrollmentId')}
      </h2>
    );
  }

  return (
    <BaseLoader studyPlanEnrollmentId={studyPlanEnrollmentIdValid}>
      {(data) => (
        <Col className="mt-4 px-0">
          <ProgressByCurrentPeriod
            progressCurrentPeriod={data.progressCurrentPeriod}
            periodActive={data.periodActive}
            texts={texts.progress}
          />
        </Col>
      )}
    </BaseLoader>
  );
}
